import { render, staticRenderFns } from "./TrustAdditionalRole.vue?vue&type=template&id=706d23ed&scoped=true"
import script from "./TrustAdditionalRole.vue?vue&type=script&lang=js"
export * from "./TrustAdditionalRole.vue?vue&type=script&lang=js"
import style0 from "./TrustAdditionalRole.vue?vue&type=style&index=0&id=706d23ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706d23ed",
  null
  
)

export default component.exports